import Swal from 'sweetalert2';
import { handleTabImagesAI } from '~src/sidebar/index';
import { fetchAiCredits } from '~graphql/controllers';

export default async function refreshAiCredits(initialCredits) {
  const MAX_WAIT_TIME = 15000; // 15 seconds
  const CHECK_INTERVAL = 1000; // Check every second

  Swal.fire({
    title: 'Aggiornamento del saldo crediti',
    text: 'Attendere prego...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    showCancelButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  const startTime = Date.now();
  let creditsUpdated = false;
  let currentCredits = initialCredits;

  while (Date.now() - startTime < MAX_WAIT_TIME && !creditsUpdated) {
    try {
      // Fetch the current AI credits
      const credits = await fetchAiCredits();
      const fetchedTotalCredits =
        credits.edges[0].freeCreditsAmount + credits.edges[0].paidCreditsAmount;

      // Check if credits have changed
      if (fetchedTotalCredits !== initialCredits) {
        currentCredits = fetchedTotalCredits;
        creditsUpdated = true;
        break;
      }

      // Wait before the next check
      await new Promise((resolve) => setTimeout(resolve, CHECK_INTERVAL));
    } catch (error) {
      console.error('Error checking AI credits:', error);
      // Continue retrying even if there's an error
    }
  }

  // Update the UI regardless of whether credits were updated
  await handleTabImagesAI();

  if (creditsUpdated) {
    Swal.fire({
      icon: 'success',
      title: 'Pagamento completato!',
      text:
        'Il tuo acquisto è stato processato con successo. I crediti sono disponibili immediatamente.',
      confirmButtonColor: '#278e8e',
    });
  } else {
    Swal.fire({
      icon: 'warning',
      title: 'Pagamento inizializzato',
      text:
        'Il pagamento è stato inizializzato. Se il tuo metodo di pagamento ha fondi disponibili, i crediti saranno disponibili a breve. Ricarica la pagina per verificare il saldo.',
      confirmButtonColor: '#278e8e',
    });
  }

  return currentCredits;
}
